import { useContext, useEffect, useRef, useState } from "react";
import { Backdrop, CircularProgress, Tooltip } from "@mui/material";
import { ArrowLeft, Check, Edit } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { QuestionCircleFill } from "react-bootstrap-icons";
import API from "../../API/newIndex";
import { ChangePathContext } from "../../App";
import { BardSvg } from "../../Assets/StaticData/BardSvg";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { GenerateSlugName } from "../../controllers/GenerateSlugName";
import { clientData } from "../../controllers/GetClient";
import { parentNavigate } from "../../controllers/ParentNavigate";
import SourceCode from "../../controllers/SourceCode";
import { useRoutingByType } from "../../controllers/useRouting";
import { uploadTextEditorImage } from "../../utilities/staticFunction";
import Notification from "../Notification";
import { InputComponent, ButtonComponent, SelectComponent, DetailsComponent, RichTextEditor } from '@shopeasy-dashboard-ui/ui-library';
import AiTextGenerate from "../AiTextGenerate";

function AddPCategory() {
  const { saveChanges, setSaveChanges } = useContext(ChangePathContext);
  const [SelectedPortfolioParentCategory, setSelectedPortfolioParentCategory] = useState();
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [PortfolioCatData, setPortfolioCatData] = useState({
    portfoliocategory_name: "",
    meta_tag_title: "",
    meta_tag_description: "",
    keyword: "",
  });
  const [isMetaTitleCustom, setIsMetaTitleCustom] = useState(false);
  const [description, setDescription] = useState("");
  const { portfoliocategory_name, meta_tag_title, meta_tag_description, keyword } =
    PortfolioCatData;

  const protocol = process.env.REACT_APP_ENVIRONMENT === 'DEV' ? 'http://' : 'https://';
  const clientInfo = clientData;
  const portfolioRoute = useRoutingByType("portfolio");

  const HandleInput = (e) => {
    if (e.target.name === "meta_tag_title") {
      setIsMetaTitleCustom(Boolean(e.target.value));
    }
    setPortfolioCatData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const [ParentCategory, setParentCategory] = useState([]);

  const GetParentCategory = async () => {
    try {
      const data = await API({
        url: `/admin/portfoliocategory/GetPortfolioCategoriesWithParent?default=true`,
        method: "get",
        params: { limit: "all" },
      });
      if (data.status === 200 || data.status === 304) {
        const result = data?.data;
        setParentCategory(result);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  const [enableSlug, setEnableSlug] = useState(false);
  const slugInputRef = useRef(null);
  const [slugEdited, setSlugEdited] = useState(false);
  const [slugName, setSlugName] = useState("");

  const handleSlug = async (slug) => {
    if (slug?.length) {
      setSlugName(await GenerateSlugName(slug));
    } else {
      setSlugName("");
    }
  };

  useEffect(() => {
    GetParentCategory();
  }, []);

  const [err, setErr] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const HandleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    try {
      const payload = {
        ...PortfolioCatData,
        description: description,
        portfolio_category_slug_name: slugName,
        ...(SelectedPortfolioParentCategory
          ? { parent_portfoliocategory: SelectedPortfolioParentCategory }
          : ""),
      };
      const data = await API({
        url: "/admin/portfoliocategory/addPortfolioCategory",
        method: "post",
        data: payload,
      });
      if (data.status === 200 || data.status === 304) {
        setSaveChanges({
          isUnsaveChanges: false,
          showChangesPopup: false,
          backLink: "/portfolio/categories",
          title: "add portfolio category",
        });
        parentNavigate("/portfolio/categories");
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
    setBtnLoading(false);
  };

  const [AiLoader, setAiloader] = useState(false);

  const generateMetaData = async (data, key) => {
    if (description?.length === 0) {
      setIsNotification(true);
      setNotificationMsg("Please enter description!");
      setSeverity("error");
    } else {
      try {
        setAiloader(true);
        const payload = { name: data };
        if (key === "description") {
          let ApiCall = await API({
            url: "/admin/ai/category_meta_description",
            method: "post",
            data: payload,
          });
          const result = ApiCall?.data;
          setPortfolioCatData({
            ...PortfolioCatData,
            meta_tag_description: result?.data,
          });
        } else {
          let ApiCall = await API({
            url: "/admin/ai/category_meta_title",
            method: "post",
            data: payload,
          });
          const result = ApiCall?.data;
          setIsMetaTitleCustom(true);
          setPortfolioCatData((prev) => ({ ...prev, meta_tag_title: result?.data }));
        }
        setAiloader(false);
      } catch (error) {
        if (error?.response?.status === 429) {
          setIsNotification(true);
          setNotificationMsg(t("lang_Hit_chatgpt_limit"));
          setSeverity("warning");
        } else {
          setIsNotification(true);
          setNotificationMsg(error?.response?.data?.message);
          setSeverity("error");
        }
      } finally {
        setAiloader(false);
      }
    }
  };

  const handleQuillChange = (value) => {
    setDescription(value);
  };

  const [html, setHtml] = useState({ htmlPP: false, code: "" });
  const saveHTML = (value) => {
    setHtml({ ...html, htmlPP: false });
    setDescription(value);
  };
  const closeCode = () => {
    setHtml({ ...html, htmlPP: false });
  };

  useEffect(() => {
    if (
      portfoliocategory_name?.length > 0 ||
      description?.length > 0 ||
      slugName?.length > 0 ||
      meta_tag_title?.length > 0 ||
      meta_tag_description?.length > 0
    ) {
      setSaveChanges({
        backLink: "/portfolio/categories",
        isUnsaveChanges: true,
        showChangesPopup: false,
        title: "add portfolio category",
      });
    } else {
      setSaveChanges({
        backLink: "/portfolio/categories",
        isUnsaveChanges: false,
        showChangesPopup: false,
        title: "add portfolio category",
      });
    }
  }, [portfoliocategory_name, description, slugName, meta_tag_title, meta_tag_description]);

  const checkChanges = () => {
    if (
      portfoliocategory_name?.length > 0 ||
      description?.length > 0 ||
      slugName?.length > 0 ||
      meta_tag_title?.length > 0 ||
      meta_tag_description?.length > 0
    ) {
      setSaveChanges({
        isUnsaveChanges: true,
        showChangesPopup: true,
        backLink: "/portfolio/categories",
        title: "add portfolio category",
      });
    } else {
      parentNavigate("/portfolio/categories");
    }
  };

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      {AiLoader && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={AiLoader}
          className="flex flex-col"
        >
          <CircularProgress color="inherit" />
          <p>{t("lang_ai_generate_content_loader")}</p>
        </Backdrop>
      )}

      <div className="h-auto overflow-y-auto pb-[130px] pt-5">
        <div className="px-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto">
            <div className="flex items-center space-x-2">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  checkChanges();
                }}
                className="back-arrow -ml-3.5"
              >
                <ArrowLeft />
              </button>
              <div className="flex-1 min-w-0">
                <Breadcrumbs
                  crumbs={[
                    { name: t("lang_Portfolio_Categories"), path: "/portfolio/categories" },
                    {
                      name: t("lang_Add_Portfolio_Category"),
                      path: "/portfolio/categories/add",
                    },
                  ]}
                />
                <div className="flex flex-wrap items-center gap-2 sm:gap-3 mt-1">
                  <h4 className="text-xl md:text-2xl font-semibold text-primary">
                    {t("lang_Add_New_Portfolio_Category")}
                  </h4>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://help.shopeasy.ai/articles/portfolio"
                    className="how-it-works !m-0"
                  >
                    <QuestionCircleFill className="me-1.5" />
                    {t("lang_how_to_use")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-[20px]">

          <form
            onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
            method="POST"
            className="w-full lg:w-[70%] xl:w-[60%] mx-auto flex flex-col gap-3"
          >
            <DetailsComponent
              open={true}
              hasHr={false}
              showChevron={false}
              className="!pt-5 sm:!pt-[25px]"
            >
              <div className="w-full mb-4">
                <label htmlFor="portfoliocategory_name" className="flex items-center justify-between">
                  <p className="text-[13px]">
                    {t("lang_Portfolio_Category_Name")}
                    <span className="text-red-500 ms-1">*</span>
                  </p>
                </label>
                <InputComponent
                  id="portfoliocategory_name"
                  name="portfoliocategory_name"
                  value={portfoliocategory_name}
                  onChange={(e) => {
                    const newName = e.target.value;
                    setErr(false);
                    if (!enableSlug && (!slugEdited || !slugName)) handleSlug(newName);
                    const shouldSyncMeta = !isMetaTitleCustom;
                    setPortfolioCatData((prev) => ({
                      ...prev,
                      portfoliocategory_name: newName,
                      ...(shouldSyncMeta ? { meta_tag_title: newName } : {}),
                    }));
                  }}
                  placeholder="e.g. Tech"
                  error={err && portfoliocategory_name?.length === 0 ? t("lang_Please_Enter_Portfolio_Category") : ""}
                  onBlur={() => {
                    if (!enableSlug && (!slugEdited || !slugName) && portfoliocategory_name) handleSlug(portfoliocategory_name);
                    if (!isMetaTitleCustom && !meta_tag_title && portfoliocategory_name) {
                      setPortfolioCatData((prev) => ({ ...prev, meta_tag_title: portfoliocategory_name }));
                    }
                  }}
                />
                <div className="flex items-center justify-between mt-1 text-xs text-gray-500 w-full gap-1 min-h-[24px]">
                  <div className="flex items-center w-[90%] min-w-0">
                    <a
                      href={`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${portfolioRoute}/portfolio-category/${(slugName || '').toLowerCase()}`}
                      target="_blank"
                      rel="noreferrer"
                      className="font-medium shrink-0 mr-2 hover:underline cursor-pointer text-blue-600 flex items-center"
                    >
                      Preview
                    </a>
                    {/* INLINE EDIT */}
                    {!enableSlug ? (
                      <div className="flex items-center gap-2 min-w-0">
                        <span className="truncate text-gray-500 min-w-0">
                          {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${portfolioRoute}/portfolio-category/${(slugName || '').toLowerCase()}`}
                        </span>

                        <button
                          type="button"
                          onClick={() => {
                            setEnableSlug(true);
                            setTimeout(() => slugInputRef.current?.focus(), 50);
                          }}
                          className="text-gray-600 hover:text-black shrink-0 flex items-center"
                        >
                          <Edit size={14} />
                        </button>
                      </div>
                    ) : (
                      <div className="flex items-center gap-1 min-w-0 flex-1">
                        <span className="text-gray-400 shrink truncate max-w-[120px] sm:max-w-[200px] md:max-w-[300px] lg:max-w-[400px]">
                          {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${portfolioRoute}/portfolio-category/`}
                        </span>

                        <InputComponent
                          ref={slugInputRef}
                          name="portfolio_category_slug_name"
                          className="flex-1 min-w-[60px] !h-[22px] !py-0.5 !px-1 text-xs"
                          value={slugName || ''}
                          onChange={(e) => {
                            setSlugName(e.target.value);
                            setSlugEdited(Boolean(e.target.value));
                          }}
                          onBlur={async () => {
                            if (slugName) {
                              const generated = await GenerateSlugName(slugName);
                              setSlugName(generated);
                            }
                          }}
                          onKeyDown={async (e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              if (!slugName) {
                                setIsNotification(true);
                                setSeverity("warning");
                                setNotificationMsg("Slug can not be empty!");
                                return;
                              }
                              const generated = await GenerateSlugName(slugName);
                              setSlugName(generated);
                              setEnableSlug(false);
                              setSlugEdited(true);
                            }
                          }}
                          isSlug={true}
                        />

                        <button
                          type="button"
                          className="text-green-600 ml-1 shrink-0 flex items-center"
                          onClick={async () => {
                            if (!slugName) {
                              setIsNotification(true);
                              setSeverity("warning");
                              setNotificationMsg("Slug can not be empty!");
                              return;
                            }

                            const generated = await GenerateSlugName(slugName);
                            setSlugName(generated);
                            setEnableSlug(false);
                            setSlugEdited(true);
                          }}
                        >
                          <Check size={14} />
                        </button>
                      </div>
                    )}
                  </div>

                  <span className={`shrink-0 text-end w-[10%] flex items-center justify-end ${(portfoliocategory_name?.length || 0) > 60 ? 'text-red-500 font-semibold' : ''}`}>
                    {portfoliocategory_name?.length || 0}/60
                  </span>
                </div>
              </div>

              <div className="mb-4">
                <label htmlFor="parentCategory">{t("lang_Parent_Portfolio_Category")}</label>
                <SelectComponent
                  name="SelectedPortfolioParentCategory"
                  placeholder="Select parent category"
                  value={SelectedPortfolioParentCategory}
                  options={
                    ParentCategory?.data?.records
                      ? ParentCategory.data.records.map((c) => ({
                        value: c._id,
                        label: c.parent_category || c.portfoliocategory_name,
                      }))
                      : []
                  }
                  onChange={(e) => setSelectedPortfolioParentCategory(e.target.value)}
                />
              </div>

              <div className="mb-4">
                <label htmlFor="description" className="block mb-1">{t("lang_description")}</label>
                <RichTextEditor
                  htmlData={description}
                  setHtmlData={handleQuillChange}
                  uplaodImageFile={uploadTextEditorImage}
                />
                <div className="w-full flex justify-end mt-1">
                  <p className="text-xs text-gray-400">
                    {`${description?.split(/\s+/)?.filter(Boolean)?.length || 0}/280 words`}
                  </p>
                </div>
              </div>
            </DetailsComponent>

            <DetailsComponent
              title={t("lang_search_engine_listing")}
              subtitle={t("lang_search_engine_listing_detail")}
              contentClassName="px-4 sm:px-[25px] pb-4 sm:pb-[25px]"
            >

              <div className="mb-4">
                <AiTextGenerate
                  fieldLabel={t("lang_meta_title")}
                  label={t("lang_get_meta_title")}
                  tooltip={t("lang_meta_tooltip", { type: "title" })}
                  onGenerate={() => generateMetaData(description || portfoliocategory_name, "title")}
                />
                <InputComponent
                  id="Meta Tag Title"
                  name="meta_tag_title"
                  value={meta_tag_title}
                  onChange={HandleInput}
                  placeholder="Enter meta title"
                />
                <div className="flex w-full justify-end mt-1">
                  <p className={`text-xs mt-0 ${(meta_tag_title?.length || 0) > 60 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                    {`${meta_tag_title?.length || 0}/60`}
                  </p>
                </div>
              </div>

              <div className="mb-4">
                <AiTextGenerate
                  fieldLabel={t("lang_meta_description")}
                  label={t("lang_get_meta_description")}
                  tooltip={t("lang_meta_tooltip", { type: "description" })}
                  onGenerate={() => generateMetaData(description, "description")}
                />
                <textarea
                  className="w-full h-24 block px-3 py-2 border border-[var(--border-color)] rounded-lg focus:outline-none focus:border-[var(--focus-border-color)] bg-[var(--secondary-bg-color)] text-[var(--primary-text-color)] text-sm"
                  id="Meta Tag description"
                  name="meta_tag_description"
                  value={(meta_tag_description || '').replace(/<[^>]+>/g, '')}
                  onChange={HandleInput}
                  placeholder="Enter meta description"
                />
                <div className="flex w-full justify-end mt-1">
                  <p className={`text-xs mt-0 ${((meta_tag_description || '').replace(/<[^>]+>/g, '').length || 0) > 160 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                    {`${(meta_tag_description || '').replace(/<[^>]+>/g, '').length || 0}/160 words`}
                  </p>
                </div>
              </div>

              <div>
                <InputComponent
                  id="keyword"
                  name="keyword"
                  label={t("lang_meta_keywords")}
                  value={keyword}
                  onChange={HandleInput}
                  placeholder="e.g. Portfolio showcase"
                />
              </div>
            </DetailsComponent>
          </form>
        </div>
      </div>

      <div className="flex items-center shadow fixed justify-between w-full bottom-[0px] z-50 secondary-bg-color border-t main-border-color p-4 left-0">
        <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto flex items-center justify-between">
          <ButtonComponent
            variant="link"
            icon={<ArrowLeft className="w-3 h-3" />}
            onClick={(e) => {
              e.preventDefault();
              checkChanges();
            }}
            className="text-[var(--table-text-color)]"
          >
            {t("lang_Go_To_Portfolio_Categories")}
          </ButtonComponent>
          <div>
            {portfoliocategory_name === "" ? (
              <ButtonComponent variant="primary" disabled>
                {t("lang_Add_Portfolio_Category")}
              </ButtonComponent>
            ) : (
              <ButtonComponent
                variant="primary"
                loading={btnLoading}
                onClick={(e) => HandleSubmit(e)}
              >
                {t("lang_Add_Portfolio_Category")}
              </ButtonComponent>
            )}
          </div>
        </div>
      </div>

      {html?.htmlPP && (
        <SourceCode
          open={html?.htmlPP}
          htmlCode={html?.code}
          closeCode={closeCode}
          saveHTML={saveHTML}
        />
      )}
    </>
  );
}

export default AddPCategory;
